import { IIconTitleAsProps } from '../../../../../sp-types/routeDetailsType';
import { routeDetailsIcons } from '../../routeDetailsUtils';
import React from 'react';

export const InputRouteMainTitle: React.FC<IIconTitleAsProps> = ({ title, icon, update = () => {} }) => {
  return (
    <div className="flex gap-2">
      <select
        className=" min-w-[3rem] border"
        value={icon}
        onChange={(event) => {
          const newIcon = event.target.value;
          update({ title, icon: newIcon });
        }}
      >
        {Object.entries(routeDetailsIcons).map(([key]) => (
          <option key={key} value={key}>
            {key}
          </option>
        ))}
      </select>
      <input
        type="text"
        className="border-b border-red flex-1 self-start pb-1"
        value={title}
        onChange={(event) => {
          const newTitle = event.target.value;
          update({ title: newTitle, icon });
        }}
      />
    </div>
  );
};
